import { Component, ElementRef, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Service } from '../service';
import { FCToasterService } from '../common/toaster/FCToasterService';
import { syncGatewayInfo } from '../common/models/syncGatewayInfo';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-gateway-info',
    templateUrl: './gateway-info.component.html',
    styleUrls: ['./gateway-info.component.scss'],
    standalone: false
})
export class GatewayInfoComponent {
  @ViewChild('gridSection') gridSection: ElementRef;
  gatewayFilter: any[];
  txtGWSrchUnit: string;
  unitlist: any[];
  rowDataUnit1: any[];
  rowDataUnit2: any[];
  rowDataUnit3: any[];
  rowDataUnit4: any[];
  columnDefs: any[];
  gridOptions: GridOptions;
  unitnNumber1: string;
  unitnNumber2: string;
  unitnNumber3: string;
  unitnNumber4: string;
  unitNumbers: any;
  selUnitNumbers: string ="";
  unitMacAddresses: any;
  chkUnit1: boolean = false;
  chkUnit2: boolean = false;
  chkUnit3: boolean = false;
  chkUnit4: boolean = false;
  gatewayFilterSelectedId: number = 1;
  gatewayFilterSelectedText: string = "Building Name";
  selGatewayMacAddress: string;
  tempGatewayMacAddress: string="";
  lblDisplayU2: boolean= false;
  lblDisplayU3: boolean= false;
  lblDisplayU4: boolean= false;
  hasMultipleMac: boolean = false;
  syncInfo = {} as syncGatewayInfo;
  DisableMobilineDev: boolean = false;
  isSyncEnabled: boolean = false;
  closeResult: string;
  isG3MSSync: boolean = false;
  txtGWPwd: string;
  
  constructor(private apiService: Service,private toastr: FCToasterService,private modalService: NgbModal) {}
  ngOnInit(): void {
    this.gatewayFilter = [{"id":1,"name": "Building Name"}, 
                          {"id":2,"name": "Building ID"}, 
                          {"id":3,"name": "Gateway MAC Address"},
                          {"id":4,"name": "Unit Number"}, 
                          {"id":5,"name": "CP-ID"}];
    this.gridOptions = {            
      defaultColDef: { filter: false },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      pagination: false,
      paginationAutoPageSize: false,
      rowSelection: 'multiple',
      suppressRowClickSelection: false,
      headerHeight: 40,
      rowHeight: 32,
      domLayout: 'autoHeight'
    }        
    this.unitlist = [];
    this.rowDataUnit1 = [];    
    this.rowDataUnit2 = [];
    this.rowDataUnit3 = [];
    this.rowDataUnit4 = [];
    this.selGatewayMacAddress = "";
    this.bindGridOnPageLoad();
    this.tempGatewayMacAddress = "";
  }

  bindGridOnPageLoad() {
    this.columnDefs = [      
      { headerName: "Source", field: "source", sortable: true, minWidth: 130, flex: 1.3, tooltipField: "source", headerTooltip: "Source" },
      { headerName: "Building Name", field: "buildingName", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "buildingName", headerTooltip: "Building Name" },
      { headerName: "Building Id", field: "buildingId", sortable: true, minWidth: 160, flex: 1.6, resizable: true, tooltipField: "buildingId", headerTooltip: "Building Id" },
      { headerName: "Building Address", field: "buildingAddress", sortable: true, minWidth: 350, flex: 3.5, resizable: true, tooltipField: "buildingAddress", headerTooltip: "Building Address" },
      { headerName: "Gateway Type", field: "gatewayType", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "gatewayType", headerTooltip: "Gateway Type" },
      { headerName: "Gateway Mac Address", field: "gatewayMacAddress", sortable: true, minWidth: 220, flex: 2.2, tooltipField: "gatewayMacAddress", headerTooltip: "Gateway Mac Address" },
      { headerName: "SIM Card ICCID1", field: "simCardICCID1", sortable: true, minWidth: 220, flex: 2.2, resizable: true, tooltipField: "gatewayIccId", headerTooltip: "SIM Card ICCId1" },
      { headerName: "SIM Card ICCID2", field: "simCardICCID2", sortable: true, minWidth: 220, flex: 2.2, resizable: true, tooltipField: "gatewayIccId2", headerTooltip: "SIM Card ICCId2" },
      { headerName: "UUID", field: "uuid", sortable: true, minWidth: 250, flex: 2.5, tooltipField: "uuid", headerTooltip: "UUID" }
    ];
  }

  gatewayFilterSelectChanged($event) {
    this.gatewayFilterSelectedId = $event.target.value;
    this.gatewayFilterSelectedText = $event.target.options[$event.target.selectedIndex].text; 
    this.txtGWSrchUnit = ""; this.hasMultipleMac = false; this.clearGrid();
    this.selGatewayMacAddress = "";
  }

  gatewaymacSelectChanged($event) {
    this.selGatewayMacAddress = $event.target.value;
    this.bindUnitlist();
    this.clearCheckboxes();
  }

  onKeyEnter(){
    this.getGatewayInfoByFilterSearch();
  }

  clearMacAddress(){
    this.selGatewayMacAddress = "";
    this.hasMultipleMac = false;
  }

  getGatewayInfoByFilterSearch(){
    if(this.txtGWSrchUnit != null && this.txtGWSrchUnit != undefined && this.txtGWSrchUnit.trim() != "")
    {
      this.apiService
        .getGatewayUnitsByFilterSearch(this.txtGWSrchUnit, this.gatewayFilterSelectedId)
        .subscribe((data: any) => {
          if (data != null) {
            this.unitlist = data;
            this.unitMacAddresses = [...new Set(this.unitlist.map(item => item.gatewayMacAddress))];
            this.hasMultipleMac = this.unitMacAddresses.length > 1 ? true : false;
            if(this.selGatewayMacAddress == ""){
                this.selGatewayMacAddress = this.unitMacAddresses[0];    
                if(this.tempGatewayMacAddress.length > 0){
                  this.selGatewayMacAddress = this.tempGatewayMacAddress;
                }
            }            
            this.bindUnitlist();   
            this.clearCheckboxes();
            setTimeout(() => {
              if (this.gridSection) {
                this.gridSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }, 100);
          }
          else {
            this.unitlist = [];this.unitMacAddresses = [];this.hasMultipleMac = false;
            this.clearGrid();
            this.toastr.showError("No Gateway Commissioned Devices Found");
          }
        });
      }
      else{
        this.toastr.showError("Please enter " + this.gatewayFilterSelectedText);
      }
  }

  bindUnitlist()
  {    
    this.lblDisplayU2 = this.lblDisplayU3 = this.lblDisplayU4 =  false;
    this.unitnNumber1 = this.unitnNumber2 = this.unitnNumber3 = this.unitnNumber4 = "";
    this.unitNumbers = [...new Set(this.unitlist.filter(x => x.gatewayMacAddress == this.selGatewayMacAddress || x.gatewayMacAddress == "").map(item => item.unitNumber))];
    this.rowDataUnit1 = this.unitlist.filter(x=> x.unitNumber == this.unitNumbers[0] && x.gatewayMacAddress == this.selGatewayMacAddress);
    this.DisableMobilineDev = this.unitlist.filter(x=> x.unitNumber == this.unitNumbers[0] && x.gatewayMacAddress == this.selGatewayMacAddress)[0]["gatewayType"].indexOf("Mobiline") > 1 ? true : false;
    this.isSyncEnabled = true;
    if(this.rowDataUnit1.length > 0)
    {
      this.unitnNumber1 = this.unitNumbers[0];      
    }

    this.rowDataUnit2 = this.unitlist.filter(x=> x.unitNumber == this.unitNumbers[1] && x.gatewayMacAddress == this.selGatewayMacAddress);
    if(this.rowDataUnit2.length > 0)
    {
      this.unitnNumber2 = this.unitNumbers[1];this.lblDisplayU2 = true;    
    }
    
    this.rowDataUnit3 = this.unitlist.filter(x=> x.unitNumber == this.unitNumbers[2] && x.gatewayMacAddress == this.selGatewayMacAddress);
    if(this.rowDataUnit3.length > 0)
    {
      this.unitnNumber3 = this.unitNumbers[2];this.lblDisplayU3 = true;
    }

    this.rowDataUnit4 = this.unitlist.filter(x=> x.unitNumber == this.unitNumbers[3] && x.gatewayMacAddress == this.selGatewayMacAddress);
    if(this.rowDataUnit4.length > 0)
    {
      this.unitnNumber4 = this.unitNumbers[3];this.lblDisplayU4 = true;
    }    
  }

  resetFilters(){
      this.gatewayFilterSelectedId = 1;this.txtGWSrchUnit = "";this.hasMultipleMac = false;
      this.clearGrid();this.gatewayFilterSelectedText = "Building Name";
      this.unitlist = [];this.unitMacAddresses = [];this.hasMultipleMac = false;
      this.DisableMobilineDev = false;
      this.isSyncEnabled = false;
  }

  clearGrid()
  {
    this.unitnNumber1 = ""; this.unitnNumber2 = "";
    this.unitnNumber3 = ""; this.unitnNumber4 = "";this.unitNumbers = "";  
    this.lblDisplayU2 = this.lblDisplayU3 = this.lblDisplayU4 =  false;
    this.rowDataUnit1 = this.rowDataUnit2 = this.rowDataUnit3 = this.rowDataUnit4 = [];
    this.isSyncEnabled = false;
    this.txtGWPwd = "";this.selGatewayMacAddress = "";
  }

  clearCheckboxes()
  {
    this.chkUnit1 = this.chkUnit2 = this.chkUnit3 = this.chkUnit4 = false;
  }

  UpdateGatewayInfo(){    
    this.syncInfo.IsG3MSSync = this.isG3MSSync;
    this.syncInfo.ElevatorUnitNumbers = [];
    if(this.chkUnit1){ this.syncInfo.ElevatorUnitNumbers.push(this.unitnNumber1)}
    if(this.chkUnit2){ this.syncInfo.ElevatorUnitNumbers.push(this.unitnNumber2)}
    if(this.chkUnit3){ this.syncInfo.ElevatorUnitNumbers.push(this.unitnNumber3)}
    if(this.chkUnit4){ this.syncInfo.ElevatorUnitNumbers.push(this.unitnNumber4)}
    this.syncInfo.GatewayMacAddress = this.selGatewayMacAddress;
    this.syncInfo.GatewayPassword = this.txtGWPwd;

    this.apiService
      .insertGatewaySyncInfo(this.syncInfo)
      .subscribe((data: any) => {
        if (data) {
          this.toastr.showSuccess("Gateway Sync Completed Successfully !!");
          this.tempGatewayMacAddress = this.selGatewayMacAddress;
          this.getGatewayInfoByFilterSearch();            
          this.chkUnit1 = this.chkUnit2 = this.chkUnit3 = this.chkUnit4 = false;
          this.modalService.dismissAll();
        }
        else {
          this.toastr.showError("Gateway Sync Failed !!");
        }
      });    
  }

  open(content, selIsG3MSSync) {    
    if(this.chkUnit1 || this.chkUnit2 || this.chkUnit3 || this.chkUnit4)  
    {
        this.selUnitNumbers = "";
        this.txtGWPwd = "";
        if(this.chkUnit1)
          this.selUnitNumbers = this.unitnNumber1;
        if(this.chkUnit2)
          this.selUnitNumbers += (this.selUnitNumbers.length > 0 ? ", " : "") + this.unitnNumber2;
        if(this.chkUnit3)
          this.selUnitNumbers += (this.selUnitNumbers.length > 0 ? ", " : "") + this.unitnNumber3;
        if(this.chkUnit4)
          this.selUnitNumbers += (this.selUnitNumbers.length > 0 ? ", " : "") + this.unitnNumber4;

        this.isG3MSSync = selIsG3MSSync;
        this.modalService.open(content, { windowClass: "eloUpdateStyle", ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });    
    }
    else
    {
      this.toastr.showError("Please select at least one unit to proceed");
    }
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}

